<template>
  <div class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="student"
      label-position="right"
      label-width="130px"
      :disabled="!!student.is_reviewing || !!student.is_archive"
    >
      <el-form-item label="姓名" prop="student_name">
        <el-input v-model="student.student_name" maxlength="14" show-word-limit clearable/>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="student.nickname" maxlength="14" show-word-limit clearable/>
      </el-form-item>

      <v-input-phone v-model="student.phone" :exclude-student-id="id" :is-diff="isPhoneDiff"/>

      <v-image-upload
        v-model="student.selfie"
        :is-edit="true"
        label="真人自拍"
        prefix="student"
        ratio="1:1"
        prop-name="selfie"
        :disabled="!!student.is_reviewing"
      />
      <v-image-upload
        v-model="student.avatar"
        :is-edit="true"
        label="头像"
        prefix="student"
        ratio="1:1"
        :disabled="!!student.is_reviewing"
      />

      <el-form-item label="性别">
        <el-radio-group v-model="student.gender" size="medium">
          <el-radio :label="0" border>保密</el-radio>
          <el-radio :label="1" border>男生</el-radio>
          <el-radio :label="2" border>女生</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="生日" prop="birthday">
        <el-date-picker
          v-model="student.birthday"
          :picker-options="pickerOptionsBirthday"
          align="right"
          type="date"
          placeholder="请选择生日"
          class="date-picker"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="实名证件号" prop="id_number">
        <el-input
          v-model="student.id_number"
          maxlength="64"
          placeholder="请填写身份证、护照号等"
          show-word-limit
          clearable
        />
      </el-form-item>

      <v-input-card-number v-model="student.card_number" :exclude-student-id="id"/>
      <el-form-item label="默认支付课卡">
        <v-select-card v-model="student.used_card_id" :student-id="id"/>
      </el-form-item>

      <el-form-item label="修改原因" prop="reason">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 ~ 200 字的修改原因"
          v-model="student.reason"
          :maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <v-image-upload
        v-model="student.reason_img"
        label="原因截图"
        prefix="student-reason"
        :prop-name="isPhoneDiff ? 'reason_img' : ''"
        ratio="9:20"
        :alert="isPhoneDiff ? '修改手机号需上传与学员的沟通记录截图，以此证明经过学员本人同意，例如：让学员将原手机号和新手机号一并发送至前台微信' : ''"
        :disabled="!!student.is_reviewing"
      />

      <el-form-item v-if="!student.is_reviewing && !student.is_archive">
        <el-button
          :disabled="!!student.is_del"
          :loading="isSaving"
          type="primary"
          @click="handleSubmit"
        >
          {{ isAdministrator ? '保存' : '申请'}}修改
        </el-button>
        <el-button @click="RouteConfig.studentList.back">返回</el-button>
      </el-form-item>

    </el-form>

    <el-form v-if="student.is_archive" class="form padding-column-0" label-width="130px">
      <el-form-item>
        <el-button disabled type="primary">账号异常无法修改</el-button>
        <el-button :disabled="false" @click="RouteConfig.studentList.back">返回</el-button>
      </el-form-item>
    </el-form>
    <template v-else>
      <el-form v-if="student.is_reviewing" class="form padding-column-0" label-width="130px">
        <el-form-item>
          <el-button disabled type="primary" v-if="student.is_reviewing">修改申请审核中</el-button>
          <el-button :disabled="false" @click="RouteConfig.studentList.back">返回</el-button>
        </el-form-item>
      </el-form>
    </template>

  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/student';
import { pickerOptionsBirthday } from '@/utils/formats';
import {toMillisecond, toSecond} from "@/utils/number";

export default {
  name: RouteConfig.studentEdit.name,
  data: () => ({
    RouteConfig,
    pickerOptionsBirthday,
    isSaving: false,
    student: {
      student_name: '',
      nickname: '',
      phone: '',
      id_number: '',
      avatar: '',
      selfie: '',
      card_number: '',
      used_card_id: '',
      is_del: 0,
      gender: 0,
      birthday: '',
      reason: '',
      reason_img: '',
      is_reviewing: 0,
      is_archive: 0,
    },
    initPhone: '',
    rules: {
      student_name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
      nickname: [{ required: true, message: '请输入昵称', trigger: 'change' }],
      phone: [{ required: true, message: '请输入手机号', trigger: 'change' }],
      selfie: [{ required: true, message: '请上传真人自拍', trigger: 'change' }],
      reason: [
        { required: true, message: '请输入修改 2 ~ 200 字的修改原因', trigger: 'blur' },
        { min: 2, max: 200, message: '请输入修改 2 ~ 200 字的修改原因', trigger: 'blur' }
      ],
      reason_img: [{ required: true, message: '请上传原因截图', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
    isPhoneDiff() {
      return `${this.initPhone}` !== `${this.student.phone}`;
    },
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const post = { ...this.student };
        post.birthday = toSecond(post.birthday);
        const { isError } = await update(this.id, post);
        this.isSaving = false;
        if (isError) return;

        if (!this.isAdministrator) return RouteConfig.studentUpdateRequestList.push();
        this.$route.query.is_from_latent ? RouteConfig.latentStudentList.back() : RouteConfig.studentList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      data.birthday = toMillisecond(data.birthday) || '';
      const { student } = this;
      const updateData = {};
      Object.keys(data).forEach(key => {
        if (key in student) updateData[key] = data[key];
      });
      Object.assign(student, updateData);
      this.initPhone = updateData.phone;
    },
  },
};
</script>
